import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SupportChatWidget = lazy(() => import('./SupportChatWidget'));

declare global {
  interface Window {
    /** Set when home defers SupportChat until openChatWidget; consumed on widget mount. */
    __APT_OPEN_CHAT_PENDING__?: boolean;
  }
}

/**
 * On `/`, delay SupportChat chunk until the user opens chat (speed dial).
 * Other routes mount as before so non-home surfaces keep chat available.
 */
const DeferredSupportChatWidget: React.FC = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname === '';
  const [mounted, setMounted] = useState(!isHomePage);

  useEffect(() => {
    if (!isHomePage) {
      setMounted(true);
      return;
    }
    if (mounted) {
      return;
    }
    const onOpen = () => {
      // Flag survives until SupportChatWidget mounts (lazy chunk may miss a sync re-dispatch).
      window.__APT_OPEN_CHAT_PENDING__ = true;
      setMounted(true);
    };
    window.addEventListener('openChatWidget', onOpen);
    return () => window.removeEventListener('openChatWidget', onOpen);
  }, [isHomePage, mounted]);

  if (!mounted) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <SupportChatWidget />
    </Suspense>
  );
};

export default DeferredSupportChatWidget;
